import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';

export default function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Admin and dashboard areas get their own layout chrome (sidebars) but
  // still sit inside the public Header/Footer shell for now, keeping a
  // single global nav rather than a fully separate app shell — simpler
  // to maintain at this project's size, and the brief doesn't call for
  // a separate admin shell beyond the role-gated sidebar itself.
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
